
  <div>
    <h4 class='blog-title'> Related  Information</h4>
  </div>
    
    <div *ngFor="let entry of benefitsList; index as myCount">
      <h5 class="title" *ngIf="currentSlugPost!=entry.slug">
        <a routerLink="/benefits/{{ entry.slug }}"> <i class="fa fa-arrow-circle-right text-danger"></i>  {{ entry.title }}</a>
      </h5>
      
    </div>
  

